import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { COLORS, fontFamilyAll } from '../assets/commonComponents/COLORS';

function Content({ data, isMobile, image }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' }, // Use Material-UI breakpoints
        alignItems: 'center',
        padding: { xs: 2, sm: 3, md: 4 }, // Responsive padding
        gap: { xs: 2, md: 4 }, // Add gap for consistent spacing
      }}
    >
      {/* Divider */}
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Divider
          orientation={isMobile ? 'horizontal' : 'vertical'}
          flexItem
          sx={{
            backgroundColor: COLORS.pinkColor,
            width: { xs: '100%', md: '10px' },
            minWidth: { xs: '100%', md: '10px' },
            height: { xs: '5px', md: 'clamp(200px, 40vh, 350px)' }, // Dynamic height
            minHeight: { xs: '5px', md: '200px' },
            marginRight: { xs: 0, md: 2 },
            marginBottom: { xs: 2, md: 0 },
          }}
        />
      </Box>

      {/* Content Section */}
      <Box
        sx={{
          textAlign: 'left',
          width: { xs: '100%', md: '50%' },
          mt: { xs: 2, md: 0 },
          ml: { xs: 0, md: 3 }, // Reduced margin for better tablet support
        }}
      >
        <Typography
          variant="h3"
          fontWeight="bold"
          sx={{
            color: COLORS.pinkColor,
            fontFamily: fontFamilyAll,
            fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' }, // Responsive font size
          }}
        >
          {data.title}
        </Typography>
        <Typography
          variant="h4"
          fontWeight="bold"
          mt={1}
          sx={{
            color: COLORS.greyColor,
            fontFamily: fontFamilyAll,
            fontSize: { xs: '1.25rem', sm: '1.5rem', md: '1.75rem' },
          }}
        >
          {data.subtitle}
        </Typography>
        {data.content.map((item, index) => (
          <Typography
            key={index}
            mt={2}
            sx={{
              color: 'grey', // Ensure contrast meets WCAG (consider darker grey)
              fontFamily: fontFamilyAll,
              fontSize: { xs: '0.875rem', sm: '1rem' }, // Responsive text
            }}
          >
            {item}
          </Typography>
        ))}
      </Box>

      {/* Image Section */}
      <Box
        sx={{
          width: { xs: '100%', md: '40%' },
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          mt: { xs: 4, md: 0 },
          ml: { xs: 0, md: 4 }, // Adjusted margin
        }}
      >
        <img
          src={image}
          alt={data.title || 'Content image'} // Dynamic alt text
          style={{
            width: '100%', // Fluid width
            maxWidth: { xs: '200px', sm: '300px', md: '400px' }, // Responsive max-width
            objectFit: 'contain',
            borderRadius: '15px',
            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
          }}
        />
      </Box>
    </Box>
  );
}

export default Content;